import { render, staticRenderFns } from "./CedentInformation.vue?vue&type=template&id=4d8da5b9&scoped=true&"
import script from "./CedentInformation.vue?vue&type=script&lang=js&"
export * from "./CedentInformation.vue?vue&type=script&lang=js&"
import style0 from "./CedentInformation.vue?vue&type=style&index=0&id=4d8da5b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8da5b9",
  null
  
)

export default component.exports